import { createContext, useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export const AuthContext = createContext();

export function AuthProvider({ children }) {

  const [user, setUser] = useState(null);
  const [householdId, setHouseholdId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          setHouseholdId(userDoc.exists() ? userDoc.data().householdId ?? null : null);
        } catch (err) {
          console.error("Failed to load user data:", err);
          setHouseholdId(null);
        }
      } else {
        setHouseholdId(null);
      }
      setLoading(false);
    });

    return unsubscribe;

  }, []);

  return (
    <AuthContext.Provider value={{ user, householdId }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}